(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSection(section) {
      if (!section || section.dataset.vpcInitialized) return;
      section.dataset.vpcInitialized = 'true';

      const track = section.querySelector('.vpc-track');
      const slides = Array.from(section.querySelectorAll('.vpc-slide'));
      const prevBtn = section.querySelector('.vpc-arrow--prev');
      const nextBtn = section.querySelector('.vpc-arrow--next');
      
      if (!track || slides.length === 0) return;

      const originalCount = slides.length;

      // 1. Clone slides for infinite loop (only if original count > 1)
      if (originalCount > 1) {
        // Prepend clones
        for (let i = originalCount - 1; i >= 0; i--) {
          const clone = slides[i].cloneNode(true);
          clone.classList.add('is-clone');
          track.insertBefore(clone, track.firstChild);
        }
        // Append clones
        for (let i = 0; i < originalCount; i++) {
          const clone = slides[i].cloneNode(true);
          clone.classList.add('is-clone');
          track.appendChild(clone);
        }
      }

      // Query all slides (originals + clones)
      const allSlides = Array.from(track.querySelectorAll('.vpc-slide'));

      // Remove loading class if present
      track.classList.remove('vpc-track-loading');

      function playVideo(slide) {
        const video = slide.querySelector('video');
        if (!video) return;
        const src = video.getAttribute('data-video-src');
        if (src && video.src !== src) {
          video.src = src;
          video.load();
        }
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(err => {
            console.log('Video playback prevented:', err);
          });
        }
      }

      function pauseVideo(slide) {
        const video = slide.querySelector('video');
        if (!video) return;
        video.pause();
        video.removeAttribute('src');
        video.load();
      }

      // Initialize the IntersectionObserver with center band (middle 20%)
      const centerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          entry.target.isIntersectingCenter = entry.isIntersecting;
        });

        // Find the slide that intersects the center zone
        const activeSlide = allSlides.find(s => s.isIntersectingCenter);
        if (activeSlide) {
          allSlides.forEach(s => {
            if (s === activeSlide) {
              if (!s.classList.contains('is-active')) {
                s.classList.add('is-active');
                playVideo(s);
              }
            } else {
              if (s.classList.contains('is-active')) {
                s.classList.remove('is-active');
                pauseVideo(s);
              }
            }
          });
        }
      }, {
        root: track,
        rootMargin: '0px -40% 0px -40%',
        threshold: 0
      });

      // Observe all slides
      allSlides.forEach(slide => centerObserver.observe(slide));

      // Scroll setup & infinite loop listener
      if (originalCount > 1) {
        const setInitialScroll = () => {
          const slideWidth = allSlides[0].offsetWidth || 240;
          const gap = parseInt(window.getComputedStyle(track).gap || 40);
          const originalWidth = originalCount * (slideWidth + gap);
          track.scrollLeft = originalWidth;
        };

        // Align track to center on load
        setInitialScroll();
        setTimeout(setInitialScroll, 100);

        // Infinite loop scroll checking
        track.addEventListener('scroll', () => {
          const slideWidth = allSlides[0].offsetWidth || 240;
          const gap = parseInt(window.getComputedStyle(track).gap || 40);
          const originalWidth = originalCount * (slideWidth + gap);
          const scrollLeft = track.scrollLeft;

          if (scrollLeft < originalWidth - gap) {
            track.scrollLeft += originalWidth;
          } else if (scrollLeft > originalWidth * 2 - gap) {
            track.scrollLeft -= originalWidth;
          }
        });
      }

      // Autoplay Auto-Scroll Carousel functionality
      const autoplayEnabled = section.getAttribute('data-autoplay-enabled') === 'true';
      const autoplayInterval = parseInt(section.getAttribute('data-autoplay-interval') || 3) * 1000;
      let autoplayTimer = null;

      function startAutoplay() {
        if (!autoplayEnabled || originalCount <= 1) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
          const slideWidth = allSlides[0].offsetWidth || 240;
          const gap = parseInt(window.getComputedStyle(track).gap || 40);
          track.scrollBy({
            left: slideWidth + gap,
            behavior: 'smooth'
          });
        }, autoplayInterval);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      if (autoplayEnabled && originalCount > 1) {
        startAutoplay();

        // Pause autoplay on mouse/touch interaction
        track.addEventListener('mouseenter', stopAutoplay);
        track.addEventListener('mouseleave', startAutoplay);
        track.addEventListener('touchstart', stopAutoplay);
        track.addEventListener('touchend', startAutoplay);

        // Reset autoplay timer on manual button clicks
        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            stopAutoplay();
            startAutoplay();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            stopAutoplay();
            startAutoplay();
          });
        }
      }

      // Arrow navigation click actions
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const slideWidth = allSlides[0].offsetWidth || 240;
          const gap = parseInt(window.getComputedStyle(track).gap || 40);
          track.scrollBy({
            left: -(slideWidth + gap),
            behavior: 'smooth'
          });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const slideWidth = allSlides[0].offsetWidth || 240;
          const gap = parseInt(window.getComputedStyle(track).gap || 40);
          track.scrollBy({
            left: (slideWidth + gap),
            behavior: 'smooth'
          });
        });
      }
    }

    function initAllInstances() {
      const sections = document.querySelectorAll('[data-vpc-root]');
      sections.forEach(section => {
        const deferred = section.getAttribute('data-deferred-load') === 'true';
        
        if (deferred) {
          const setupProximity = () => {
            const proximityObserver = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  proximityObserver.disconnect();
                  initSection(section);
                }
              });
            }, {
              root: null,
              rootMargin: '200px 0px 200px 0px',
              threshold: 0
            });
            proximityObserver.observe(section);
          };

          if (document.readyState === 'complete') {
            setupProximity();
          } else {
            window.addEventListener('load', setupProximity);
          }
        } else {
          initSection(section);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllInstances);
    } else {
      initAllInstances();
    }

    document.addEventListener('shopify:section:load', function(event) {
      const section = document.getElementById(`vpc-section-${event.detail.sectionId}`);
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
